import { createSlice } from "@reduxjs/toolkit";
import notificationApi from "../../api/notificationApi";

const initialState = {
  employeesList: [],
  allNotifications: "",
  latestNotifications: "",
  count: 0,
  isAnnouncementOpen: false,
};

const notificationSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setIsAnnouncementOpen: (state, action) => {
      state.isAnnouncementOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      notificationApi.endpoints.getEmployeesList.matchFulfilled,
      (state, action) => {
        state.employeesList = action.payload;
      }
    );
    builder.addMatcher(
      notificationApi.endpoints.getNotifications.matchFulfilled,
      (state, action) => {
        state.allNotifications = action.payload;
      }
    );
    builder.addMatcher(
      notificationApi.endpoints.getLatestNotifications.matchFulfilled,
      (state, action) => {
        state.latestNotifications = action.payload;
      }
    );
    builder.addMatcher(
      notificationApi.endpoints.getNotificationCount.matchFulfilled,
      (state, action) => {
        state.count = action.payload;
      }
    );
  },
});

export const { setIsAnnouncementOpen } = notificationSlice.actions;

export default notificationSlice.reducer;
